import type { Bet } from 'src/types/domain/Bet'
import type { MarbleGame } from 'src/types/domain/Game'
import CurrentBetPane from './components/CurrentBetPane'

type Props = Readonly<{
  bet?: Bet
  game: MarbleGame
}>

export function CurrentBetPanel({ bet, game }: Props) {
  return <CurrentBetPane currentBet={bet} game={game} />
}
